import React, { FC, useEffect } from 'react';
import { Text, isEditorActive } from '@sitecore-jss/sitecore-jss-react';
import { NewsFilesModel } from './models/newsFiles.model';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import { TNewsFilesProps } from './types/newsFiles.types';
import NewsFilesDownloadCard from './components/newsFilesDownloadCard';
import CTA, { ctaTypes } from '../@shared/cta';
import { addToAnyScript } from '../../utils/addToAnyScript.utils';
import AnalyticsVisibleEvent from '../@shared/analyticsVisibleEvent';

const NewsFiles: FC<TNewsFilesProps> = (props) => {
  const model = new NewsFilesModel(props);

  useEffect(() => {
    setTimeout(() => {
      addToAnyScript();
    });
  }, []);

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  if (model.downloadFileCardLength === 0 && !isEditorActive()) {
    return null;
  }

  return (
    <section>
      <AnalyticsVisibleEvent
        rendering={props.rendering}
        title={model?.title?.value}
        template={'News Files'}
        className="download-news-files-container"
      >
        <div className="download-news-files-container__label-container">
          <Text field={model?.eyebrow} tag={'p'} className="download-news-files-container__eyebrow" />
          <Text field={model?.title} tag={'p'} className="download-news-files-container__title" />
          <div>
            <CTA field={model?.optionalCTA} type={ctaTypes.secondaryRed} extraClassName="download-news-files-container__optional-cta" />
          </div>
        </div>
        <div className="download-news-files-container__card-container">
          {model?.downloadNewsFilesCard.map((card) => (
            <NewsFilesDownloadCard {...card} key={card.id} />
          ))}
        </div>
      </AnalyticsVisibleEvent>
    </section>
  );
};

export default NewsFiles;
